import { IGetState } from '../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { closeUpdatesModal } from '../../../effects/closeUpdatesModal';

export const onClose = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(closeUpdatesModal());
    };
    return action;
};
